



























import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import { ToolbarDeactivations, ToolbarModule } from '@/store/modules/toolbar'
import { ErrorsModule } from '@/store/modules/error'
import { PaintingByNumbersModule } from '../../../store/modules/paintingByNumbers';
import { AssetsModule } from '../../../store/modules/asset'
import { AppModule } from '@/store/modules/app'


@Component({
    name: 'toolbar'
})
export default class Toolbar extends Vue {
    get showToolbar() {
        return PaintingByNumbersModule.showToolbar || AppModule.showMenu
    }

    get zoom() {
       return ToolbarModule.zoom 
    }

    set zoom(zoom: number | string) {
        let zoomNumber = Number(zoom)
        if (!Number.isNaN(zoomNumber)) {
            ToolbarModule.SetZoom(zoomNumber) 
        }
    }

    get rotation() {
       return ToolbarModule.rotation 
    }

    set rotation(rotation: number | string) {
        let rotationNumber = Number(rotation)
        if (!Number.isNaN(rotationNumber)) {
            ToolbarModule.SetRotation(rotationNumber) 
        }
    }

    get disabledZoomAndRotation() {
        return ToolbarModule.deactivated & ToolbarDeactivations.ZoomAndRotation
    }

    get disabledTrash() {
        return ToolbarModule.deactivated & ToolbarDeactivations.Deletion
    }

    get hasSelectedAssets() {
        return AssetsModule.selectedAssets.length > 0
    }

    get hidden() {
        if (AppModule.showMenu) {
            return true
        }
        if (PaintingByNumbersModule.showPainting) {
            return !(this.hasSelectedAssets && PaintingByNumbersModule.userFormat !== "")
        }
        return this.disabledZoomAndRotation && this.disabledTrash
    }

    zoomOffset(offset: number) {
        if (!this.disabledZoomAndRotation) {
            ToolbarModule.OffsetZoom(offset)
        }
    }

    rotate(offset: number) {
        if (!this.disabledZoomAndRotation) {
            ToolbarModule.OffsetRotation(offset)
        }
    }

    deselect() {
        if (!this.disabledTrash) {
            ToolbarModule.Deselect()
            let currentUsage = "paintingimage"
            let asset = PaintingByNumbersModule.activeAssets[currentUsage]
            AssetsModule.SetPendingUsage([asset, currentUsage])
            AssetsModule.SetUsage([asset, currentUsage])
            PaintingByNumbersModule.UnsetActiveAsset(currentUsage)
            if (ToolbarModule.errorKeys.includes(currentUsage)) {
                if (ToolbarModule.errorKeys.length === 1){
                    ToolbarModule.SetToolbarError(false)
                }
                ToolbarModule.UnsetErrorKey(currentUsage)
            }
        }
    }

    onConfirm() {
        let currentUsage = "paintingimage"
        if (!ToolbarModule.errorKeys.includes(currentUsage)) {
            ToolbarModule.SetConfirmed(!ToolbarModule.confirmed)
        }
    }
}
